package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.TagWithCount
import com.example.readingnotes.domain.repository.TagRepository

class LoadPopularTagsUseCase(
    private val tagRepository: TagRepository,
) {
    suspend operator fun invoke(limit: Int = 10): Result<List<TagWithCount>> = tagRepository.getPopularTags(limit)
}
